// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._11c81o8v{font:var(--ds-font-body-small,normal 400 11px/1pc ui-sans-serif,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Ubuntu,\"Helvetica Neue\",sans-serif)}\n._1bah1h6o{justify-content:center}\n._1bsb7vkz{width:1pc}\n._1e0c116y{display:inline-flex}\n._4cvr1h6o{align-items:center}\n._4t3i7vkz{height:1pc}", ""]);
// Exports
module.exports = exports;
